import { useState, useRef, type ReactNode } from 'react';

export function Tooltip({
  content,
  children,
  side = 'top',
  wide,
}: {
  content: ReactNode;
  children: ReactNode;
  side?: 'top' | 'bottom';
  wide?: boolean;
}) {
  const [visible, setVisible] = useState(false);
  const timeout = useRef<ReturnType<typeof setTimeout>>(null);

  const show = () => {
    timeout.current = setTimeout(() => setVisible(true), 400);
  };

  const hide = () => {
    if (timeout.current) clearTimeout(timeout.current);
    setVisible(false);
  };

  const positionClass =
    side === 'top'
      ? 'bottom-full mb-1.5 left-1/2 -translate-x-1/2'
      : 'top-full mt-1.5 left-1/2 -translate-x-1/2';

  return (
    <div className="relative inline-flex" onMouseEnter={show} onMouseLeave={hide}>
      {children}
      {visible && (
        <div
          className={`absolute ${positionClass} z-50 pointer-events-none rounded px-1.5 py-0.5 text-[9px] font-semibold shadow-lg ${wide ? 'w-56 whitespace-normal' : 'whitespace-nowrap'}`}
          style={{ backgroundColor: 'var(--color-ink)', color: 'var(--color-bg)' }}
        >
          {content}
        </div>
      )}
    </div>
  );
}
